module.exports = __webpack_public_path__ + "img/sec3_slide2.fba8363e.jpg";